import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle'; // keep commented if styles load elsewhere

const initGallerySwipers = () => {
  document.querySelectorAll('.gallery-swiper-block .swiper').forEach((el) => {
    if (el.dataset.swiperInitialized === '1') return;

    // eslint-disable-next-line no-new
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 14,

      // Rewind (instead of cloning)
      loop: false,
      rewind: true,

      // Autoplay
      autoplay: {
        delay: 2000,                // 2 seconds between slides
        disableOnInteraction: false // keep running after user interaction
      },
      speed: 800, // slide transition speed in ms

      watchSlidesProgress: true,
      grabCursor: true,
      observeParents: true,
      observer: true,

      preloadImages: false,
      lazy: { loadOnTransitionStart: true, checkInView: true },

      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      a11y: { enabled: true },

      breakpoints: {
        640:  { spaceBetween: 10 },
        1024: { spaceBetween: 14 },
      },
    });

    el.dataset.swiperInitialized = '1';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGallerySwipers);
} else {
  initGallerySwipers();
}